export default __webpack_public_path__ + "static/media/ec.00a71e45.svg";